
import SignUpSection from "../../components/common/SignUp";

const SignUp = () => {
    return (
        <SignUpSection />
    )
}

export default SignUp;